export const LEFT_COLUMN_STYLE = 'w-full lg:w-52';
//# sourceMappingURL=leftColumnStyle.js.map